import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import PageBreadcrumb from '../common/components/layout/PageBreadcrumb';
import LocationsTable from './table/LocationsTable';
import { setQueryString, useQueryString } from '../common/helpers/queryString';
import { getDealersCities } from '../dealers/DealersActions';
import { SEARCH_LOCATIONS_SUCCESS } from './LocationsReducer';

const breadcrumbs = [
  { id: 1, type: 'home' },
  { id: 2, type: 'span', text: 'Locations' },
];

function LocationsPage() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const items = useSelector((state) => state.locations.get('items'));
  const totalItems = useSelector((state) => state.locations.get('totalItems'));

  const query = useQueryString();
  const [searchParams, setSearchParams] = useState({
    offset: query.get('page') ? +query.get('page') - 1 : 0,
    organizationId: null,
  });

  const changeOffset = (value) => {
    setSearchParams((prevState) => ({
      ...prevState,
      offset: value,
    }));
    navigate(setQueryString(location, 'page', value + 1));
  };

  useEffect(() => {
    dispatch(
      getDealersCities(null, (payload) => {
        dispatch({
          type: SEARCH_LOCATIONS_SUCCESS,
          payload,
        });
      }),
    );
  }, [dispatch, searchParams]);

  return (
    <Container fluid>
      <PageBreadcrumb items={breadcrumbs} pageTitle="Locations" />
      <LocationsTable
        data={{ items, total: totalItems }}
        offset={searchParams.offset}
        changeOffset={changeOffset}
      />
    </Container>
  );
}

export default LocationsPage;
